export default class PermissionTree{
    id:string;
    Label:string;
    children:PermissionTree[];
}